import { Input } from "../../ui/input";

export function NumberField({
  item,
  value,
  error,
  helperText,
  disabled,
  autoFocus,
  onChange,
  onBlur,
  className,
}) {
  return (
    <Input
      type="number"
      inputMode="numeric"
      placeholder={item.placeholder}
      value={value || ""}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      autoFocus={autoFocus}
      className={`${error ? "border-red-500 hover:border-red-500 focus:border-red-500" : "border-gray-300"} ${
        className || ""
      }`}
    />
  );
}
